export const LANDING_ROUTE = '/'
export const CREATE_ROUTE = '/create/:id'
export const MANAGE_ROUTE = '/manage/:id'
export const LOGIN_ROUTE = '/login'
